import { takeLatest, takeEvery, put, select } from 'redux-saga/effects'
import { createReducer, makeAction, makeKeys, urlWithPrefix } from './helper'
import { httpPost, httpGet, httpDelete, httpPut } from '../core/restClient'
import { appLoading, appLoaded, toastError, toastSuccess } from './app'
import { billFormPath, homePath, EditBillFormPath, BillformDetailPath } from 'routes'
import { getCompanies, getVendors, } from './options'
import { getHrmsMembers, getAllMembers } from './member'
import { lower } from 'change-case'

const FETCH_BILLFORM = makeKeys('FETCH_BILLFORM')
const GET_BILLFORM_DETAIL = makeKeys('GET_BILLFORM_DETAIL')
const CREATE_BL = 'CREATE_BL'
const SUBMIT_BL = 'SUBMIT_BL'
const RESUBMIT_BL = 'RESUBMIT_BL'
const UPDATE_BILLFORM = 'UPDATE_BILLFORM'
const SAVE_BL_ATTACHEMNTS = 'SAVE_BL_ATTACHEMNTS'
const INITIALIZE_BL = 'INITIALIZE_BL'
const CLEAR_BL_DETAIL = 'CLEAR_BL_DETAIL'
const GET_GR_RELEASE = makeKeys('GET_GR_RELEASE')
const GET_GR_RELEASE_DETAIL = makeKeys('GET_GR_RELEASE_DETAIL')
const BL_ACTION = 'BL_ACTION'
const DELETE_BL = 'DELETE_BL'
const GET_BL_GOA_WORK_FLOW_VIEW_MODE = makeKeys('GET_BL_GOA_WORK_FLOW_VIEW_MODE')
const GET_BL_GOA_WORK_FLOW_EDIT_MODE = makeKeys('GET_BL_GOA_WORK_FLOW_EDIT_MODE')
const GET_BL_ERROR_WORKFLOW = makeKeys('GET_BL_ERROR_WORKFLOW')
const GET_SPECIALAPPROVAL_INFO = makeKeys('GET_SPECIALAPPROVAL_INFO')
const GET_BL_WORKFLOW_APPROVER_VIEW = makeKeys('GET_BL_WORKFLOW_APPROVER_VIEW')
const BL_FILTER_INVOICE_LIST = 'BL_FILTER_INVOICE_LIST'
const BL_REMOVE_ITEM_INVOICE_LIST = 'BL_REMOVE_ITEM_INVOICE_LIST'
const BL_ADD_ITEM_INVOICE_LIST = 'BL_ADD_ITEM_INVOICE_LIST'
const BL_RESET_INVOICE_LIST = 'BL_RESET_INVOICE_LIST'
const GET_BILLING_COVER = makeKeys('GET_BILLING_COVER')
const GET_BILLING_REPORT = makeKeys('GET_BILLING_REPORT')
const ADD_BILLING_COMMENT = makeKeys('ADD_BILLING_COMMENT')

export const initializeBL = makeAction(INITIALIZE_BL, 'isDetail')
export const filterInvoiceList = makeAction(BL_FILTER_INVOICE_LIST, 'grId')
export const removeInvoiceItemList = makeAction(BL_REMOVE_ITEM_INVOICE_LIST, 'grId')
export const addInvoiceItemList = makeAction(BL_ADD_ITEM_INVOICE_LIST, 'grId')
export const resetInvoiceList = makeAction(BL_RESET_INVOICE_LIST)
export const clearBLDetail = makeAction(CLEAR_BL_DETAIL)
export const getGRRelease = makeAction(GET_GR_RELEASE.REQUEST, 'data')
export const getGRReleaseDetail = makeAction(GET_GR_RELEASE_DETAIL.REQUEST, 'grId')
export const fetchBillform = makeAction(FETCH_BILLFORM.REQUEST, 'dataSearch')
export const getBillformDetail = makeAction(GET_BILLFORM_DETAIL.REQUEST, 'Id', 'history', 'isEdit')
export const createBL = makeAction(CREATE_BL, 'data', 'history', 'isSubmit', 'showMessage')
export const updateBillform = makeAction(UPDATE_BILLFORM, 'data', 'history', 'isSubmit', 'showMessage')
export const submitBL = makeAction(SUBMIT_BL, 'data', 'history', 'showMessage')
export const resubmitBL = makeAction(RESUBMIT_BL, 'data', 'history', 'showMessage')
export const saveBLAttachments = makeAction(SAVE_BL_ATTACHEMNTS, 'data', 'history', 'isSubmit', 'showMessage')
export const deleteBL = makeAction(DELETE_BL, 'data', 'history')
export const BLAction = makeAction(BL_ACTION, 'data', 'history', 'actionName')
export const getBLGOAWorkFlowViewMode = makeAction(GET_BL_GOA_WORK_FLOW_VIEW_MODE.REQUEST, 'blId')
export const getBLGOAWorkFlowEditMode = makeAction(GET_BL_GOA_WORK_FLOW_EDIT_MODE.REQUEST, 'data')
export const getWorkflowApproverView = makeAction(GET_BL_WORKFLOW_APPROVER_VIEW.REQUEST, 'blId')
export const getSpecialApprovalInfo = makeAction(GET_SPECIALAPPROVAL_INFO.REQUEST, 'id')
export const getBLErrorWorkFlow = makeAction(GET_BL_ERROR_WORKFLOW.REQUEST, 'procInstID', 'subProcInstID')
export const getBillingCover = makeAction(GET_BILLING_COVER.REQUEST, 'id')
export const getBillingReport = makeAction(GET_BILLING_REPORT.REQUEST, 'dateS', 'dateE', 'companyCode', 'key')
export const addComment = makeAction(ADD_BILLING_COMMENT.REQUEST, 'id', 'data', 'onSuccess')

const getGRReleaseSuccess = makeAction(GET_GR_RELEASE.SUCCESS, 'data')
const getGRReleaseDetailSuccess = makeAction(GET_GR_RELEASE_DETAIL.SUCCESS, 'data')
const fetchBillformSuccess = makeAction(FETCH_BILLFORM.SUCCESS, 'data')
const getBillformDetailSuccess = makeAction(GET_BILLFORM_DETAIL.SUCCESS, 'data')
const getGOAWorkFlowViewModeSuccess = makeAction(GET_BL_GOA_WORK_FLOW_VIEW_MODE.SUCCESS, 'data')
const getBLGOAWorkFlowEditModeSuccess = makeAction(GET_BL_GOA_WORK_FLOW_EDIT_MODE.SUCCESS, 'data')
const getBLErrorWorkFlowSuccess = makeAction(GET_BL_ERROR_WORKFLOW.SUCCESS, 'data')
const getSpecialApprovalInfoSuccess = makeAction(GET_SPECIALAPPROVAL_INFO.SUCCESS, 'data')
const fetchBillformFailure = makeAction(FETCH_BILLFORM.FAILURE)
const getBillingCoverSuccess = makeAction(GET_BILLING_COVER.SUCCESS, 'data')
const getBillingReportSuccess = makeAction(GET_BILLING_REPORT.SUCCESS, 'data')

const basePath = path => path ? urlWithPrefix(`billForm/${path}`) : urlWithPrefix('billForm')
const multipartHeader = { 'Content-Type': 'multipart/form-data', }

function* initializeBLRequest(action) {
  const {isDetail} = action.payload
  try {
    const state = yield select()
    if (!state.options.companies.data.length) {
      yield put(getCompanies())
    }
    if (!state.options.vendors.length) {
      yield put(getVendors())
    }
    yield put(getAllMembers(isDetail))
    // yield put(getHrmsMembers(isDetail))
  } catch (e) {

  }
}

function* getSpecialApprovalInfoRequest(action) {
  const { id } = action.payload
  try {
    const response = yield httpGet(`goas/specialApproval/${id}`)
    if (response.status >= 200 && response.status < 300) {
      yield put(getSpecialApprovalInfoSuccess(response.data))
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getSpecialApprovalInfo(id))
    } else {
      yield put(getSpecialApprovalInfoSuccess({}))
    }
  }
}

function* getGRReleaseRequest(action) {
  const { data } = action.payload
  try {
    const response = yield httpGet(basePath('SearchGoodsServiceReceipt'), data)
    if (response.status >= 200 && response.status < 300) {
      yield put(getGRReleaseSuccess(response.data))
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getGRRelease(data))
    } else {
      yield put(getGRReleaseSuccess([]))
    }
  }
}

function* getGRReleaseDetailRequest(action) {
  const { grId } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(basePath('GetGoodsServiceReceiptDetail'), { grId: grId })
    if (response.status >= 200 && response.status < 300) {
      yield put(getGRReleaseDetailSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getGRReleaseDetail(grId))
    } else {
      yield put(getGRReleaseDetailSuccess(null))
    }
  }
}

function* fetchBillformRequest(action) {
  const { dataSearch } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(basePath(), dataSearch)
    if (response.status >= 200 && response.status < 300) {
      yield put(fetchBillformSuccess(response.data))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(fetchBillform(dataSearch))
    } else {
      yield put(fetchBillformSuccess({}))
    }
  }
}

function* createBLRequest(action) {
  const { data, history, isSubmit, showMessage } = action.payload
  try {
    yield put(appLoading('Save Billing'))
    const response = yield httpPost(basePath(), data)
    if (response.status >= 200 && response.status < 300) {
      yield put(saveBLAttachments({ ...data, id: response.data }, history, isSubmit, showMessage))
    }
    yield put(appLoaded())
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Save Billing fail.'))
    }
    yield put(appLoaded())
  }
}

function* updateBillformRequest(action) {
  const { data, history, isSubmit, showMessage } = action.payload
  try {
    yield put(appLoading('Save Billing'))
    const response = yield httpPut(basePath(`${data.id}`), data)
    if (response.status >= 200 && response.status < 300) {
      yield put(saveBLAttachments(data, history, isSubmit, showMessage))
    }
    yield put(appLoaded())
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Save Billing fail.'))
    }
    yield put(appLoaded())
  }
}

function* saveBLAttachmentsRequest(action) {
  const { data, history, isSubmit, showMessage } = action.payload
  try {
    yield put(appLoading('Upload attachments'))
    var attachmentsData = {}
    if (data.BL01) attachmentsData.BL01 = data.BL01
    if (data.BL02) attachmentsData.BL02 = data.BL02
    if (data.BL03) attachmentsData.BL03 = data.BL03
    if (data.BL04) attachmentsData.BL04 = data.BL04
    let success = false
    if (Object.keys(attachmentsData).length) {
      const response = yield httpPost(basePath(`${data.id}/Attachments`), attachmentsData, multipartHeader)
      if (response.status >= 200 && response.status < 300) {
        success = true
      }
    } else success = true

    if (success) {
      if (isSubmit) {
        if (data.status === 3) { // status revise Resubmit
          yield put(resubmitBL(data, history, showMessage))
        } else {
          yield put(submitBL(data, history, showMessage))
        }
      } else {
        yield put(appLoaded())
        history.push(billFormPath)
        yield put(toastSuccess('Save billing success.'))
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(toastError('Upload Attachments billing fail.'))
    yield put(appLoaded())
  }
}

function* submitBLRequest(action) {
  const { data, history, showMessage } = action.payload
  try {
    yield put(appLoading(''))
    const response = yield httpPost(basePath(`${data.id}/submit`))
    if (response.status >= 200 && response.status < 300) {
      if (showMessage) {
        yield put(toastSuccess('Submit Billing success.'))
        showMessage(data.id)
      } else {
        yield put(toastSuccess('Submit Billing success.'))
        history.push(billFormPath)
      }
    }
    yield put(appLoaded())
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Submit Billing fail.'))
    }
    yield put(appLoaded())
  }
}

function* resubmitBLRequest(action) {
  const { data, history, showMessage } = action.payload
  try {
    yield put(appLoading('Resubmit BL'))
    const response = yield httpPost(basePath(`reSubmit`), { docId: data.id, sn: data.sn, comment: '' })
    if (response.status >= 200 && response.status < 300) {
      if (showMessage) {
        yield put(toastSuccess('Submit Billing success.'))
        showMessage(data.id)
      } else {
        yield put(toastSuccess('Submit Billing success.'))
        history.push(billFormPath)
      }
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(toastError('Submit Billing fail.'))
    yield put(appLoaded())
  }
}

function* deleteBLRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading('Delete Billing'))
    const response = yield httpDelete(basePath(`${data.docId}`))
    if (response.status >= 200 && response.status < 300) {
      history.push(billFormPath)
      yield put(toastSuccess('Delete Billing success.'))
    }
    yield put(appLoaded())
  } catch (e) {
    yield put(toastError('Delete Billing fail.'))
    yield put(appLoaded())
  }
}

function* getBillformDetailRequest(action) {
  const { Id, history, isEdit } = action.payload
  try {
    yield (appLoading('Loading Billing.'))
    let username = localStorage.getItem('username').toLowerCase()
    const response = yield httpGet(basePath(`${Id}`))
    if (response.status >= 200 && response.status < 300) {
      if (response.data) {
        let data = response.data
        let Creater = lower(data.createdByUser)
        let Requester = lower(data.requesterUser)
        if (data.deleted) {
          yield put(toastError('Document does not exist or document is deleted'))
          history.push(billFormPath)
        } else if (data.status == 5) {
          if (data.sn || Requester.includes(username) || Creater.includes(username) || lower(data.requesterUser) == username || lower(data.createdByUser) == username) {
            if (isEdit) {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())
            } else {
              yield put(appLoaded())
              history.push(EditBillFormPath(data.id))
            }
          } else {
            if (isEdit) {
              yield put(appLoaded())
              history.push(BillformDetailPath(data.id))
            } else {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())

            }
          }
        } else if (data.status == 3) {
          if (Requester.includes(username) || Creater.includes(username) || lower(data.requesterUser) == username || lower(data.createdByUser) == username) {
            if (isEdit) {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())
            } else {
              yield put(appLoaded())
              history.push(EditBillFormPath(data.id))
            }
          } else {
            if (isEdit) {
              yield put(appLoaded())
              history.push(BillformDetailPath(data.id))
            } else {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())
            }
          }
        } else if (data.status == 1) {
          if (Requester.includes(username) || Creater.includes(username) || lower(data.requesterUser) == username || lower(data.createdByUser) == username) {
            if (isEdit) {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())
            } else {
              yield put(appLoaded())
              history.push(EditBillFormPath(data.id))
            }
          } else {
            if (isEdit) {
              yield put(appLoaded())
              history.push(BillformDetailPath(data.id))
            } else {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())

            }
          }
        } else if (data.status == 0) {
          if (lower(data.createdByUser) == username) {
            if (isEdit) {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())
            } else {
              yield put(appLoaded())
              history.push(EditBillFormPath(data.id))
            }
          } else {
            if (isEdit) {
              yield put(appLoaded())
              history.push(BillformDetailPath(data.id))
            } else {
              yield put(getBillformDetailSuccess(response.data))
              yield put(appLoaded())
            }
          }
        } else {
          yield put(getBillformDetailSuccess(response.data))
          yield put(appLoaded())
        }
      }
    }
  } catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getBillformDetail(Id, history, isEdit))
    } else {
      if (e.data) {
        yield put(toastError(e.data.message))
      }
      yield put(getBillformDetailSuccess([]))
    }
  }
}

function* getBLGOAWorkFlowViewModeRequest(action) {
  const { blId } = action.payload
  try {
    const response = yield httpGet(basePath(`${blId}/workflowApproverViewMode`))
    if (response.status >= 200 && response.status < 300) {
      yield put(getGOAWorkFlowViewModeSuccess(response.data))
    }
  } catch (e) {
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put( getBLGOAWorkFlowViewMode(blId))
    } else {
      yield put(getGOAWorkFlowViewModeSuccess([]))
    }
  }
}

function* getBLGOAWorkFlowEditModeRequest(action) {
  const { data } = action.payload
  try {
    const response = yield httpGet(basePath('workflowApproverEditMode'), data)
    if (response.status >= 200 && response.status < 300) {
      yield put(getBLGOAWorkFlowEditModeSuccess(response.data))
    }
  } catch (e) {
    yield put(getBLGOAWorkFlowEditModeSuccess([]))
  }
}

function* getBLErrorWorkFlowRequest(action) {
  const { procInstID, subProcInstID } = action.payload
  try {
    const response = yield httpGet(`share/workflow/getErrorWorkflow`, { procInstID: procInstID, subProcInstID: subProcInstID })
    if (response.status >= 200 && response.status < 300) {
      if (response.data.success) {
        yield put(getBLErrorWorkFlowSuccess({ isError: false, msg: '' }))
      } else {
        yield put(getBLErrorWorkFlowSuccess({ isError: true, msg: response.data.message }))
      }
    }
  } catch (e) {
    yield put(getBLErrorWorkFlowSuccess({ isError: false, msg: '' }))
  }
}

function* BLActionRequest(action) {
  const { data, history } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpPost(basePath(`${data.docId}/actionApproval`), {
      docId: data.id,
      sn: data.sn,
      comment: data.comment,
      commentAttachments: data.commentAttachments,
      action: data.action,
    }, multipartHeader)
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Action Billing success.'))
      if (history.location.search.includes('h=true')) {
        history.push(homePath)
      } else {
        history.push(billFormPath)
      }
      yield put(appLoaded())
    }
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Action Billing fail.'))
    }
    yield put(appLoaded())
  }
}

function* getBillingCoverRequest(action) {
  try {
    const response = yield httpGet(`billForm/${action.payload.id}/cover`)
    if (response.status === 200) {
      yield put(getBillingCoverSuccess(response.data))
    }
  }
  catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getBillingCover(action.payload.id))
    } else {
      yield put(toastError(e.data.message))
    }
  }
}

function* getBillingReportRequest(action) {
  const { dateS, dateE, companyCode, key } = action.payload
  try {
    yield put(appLoading())
    const response = yield httpGet(basePath('report'), { dateStart: dateS, dateEnd: dateE, companyCode: companyCode || null, key: key })
    if (response.status === 200) {
      yield put(appLoaded())
      yield put(getBillingReportSuccess(response.data))
    }
  }
  catch (e) {
    yield put(appLoaded())
    if (e && e.config && e.config.headers && e.config.headers.Authorization === 'Bearer null') {
      yield put(getBillingReport(dateS, dateE, companyCode, key))
    } else {
      yield put(toastError('Get report fail'))
    }
  }
}

function* addCommentRequest(action) {
  const { id, data, onSuccess } = action.payload
  try {
    yield put(appLoading(''))
    const response = yield httpPut(basePath(`${id}/addComment`), data)
    yield put(appLoaded())
    if (response.status >= 200 && response.status < 300) {
      yield put(toastSuccess('Add comment success.'))
      if (onSuccess) { onSuccess() }
    }
  } catch (e) {
    if (e.data) {
      yield put(toastError(e.data.message))
    } else {
      yield put(toastError('Add comment fail.'))
    }
    yield put(appLoaded())
  }
}

export function* watchBillformSaga() {
  yield takeLatest(FETCH_BILLFORM.REQUEST, fetchBillformRequest)
  yield takeLatest(GET_BILLFORM_DETAIL.REQUEST, getBillformDetailRequest)
  yield takeLatest(GET_BL_GOA_WORK_FLOW_VIEW_MODE.REQUEST, getBLGOAWorkFlowViewModeRequest)
  yield takeLatest(GET_BL_GOA_WORK_FLOW_EDIT_MODE.REQUEST, getBLGOAWorkFlowEditModeRequest)
  yield takeLatest(GET_BL_ERROR_WORKFLOW.REQUEST, getBLErrorWorkFlowRequest)
  yield takeLatest(GET_GR_RELEASE.REQUEST, getGRReleaseRequest)
  yield takeEvery(GET_GR_RELEASE_DETAIL.REQUEST, getGRReleaseDetailRequest)
  yield takeLatest(CREATE_BL, createBLRequest)
  yield takeLatest(UPDATE_BILLFORM, updateBillformRequest)
  yield takeLatest(SUBMIT_BL, submitBLRequest)
  yield takeLatest(RESUBMIT_BL, resubmitBLRequest)
  yield takeLatest(SAVE_BL_ATTACHEMNTS, saveBLAttachmentsRequest)
  yield takeLatest(INITIALIZE_BL, initializeBLRequest)
  yield takeLatest(BL_ACTION, BLActionRequest)
  yield takeLatest(DELETE_BL, deleteBLRequest)
  yield takeLatest(GET_SPECIALAPPROVAL_INFO.REQUEST, getSpecialApprovalInfoRequest)
  yield takeLatest(GET_BILLING_COVER.REQUEST, getBillingCoverRequest)
  yield takeLatest(GET_BILLING_REPORT.REQUEST, getBillingReportRequest)
  yield takeLatest(ADD_BILLING_COMMENT.REQUEST, addCommentRequest)
}

const initial = {
  listBillforms: { data: {}, loading: false },
  billformDetail: { data: {}, loading: false },
  approvers: { data: [], loading: false },
  GRSearch: { data: [], buffer: [], loading: false },
  grReleaseDetail: null,
  specialApprovalInfo: { data: {}, loading: false },
  billingCoverDetail: { data: {}, loading: false },
  billingReportList: { data: [], loading: false },
}

export default createReducer(initial, state => ({
  [FETCH_BILLFORM.REQUEST]: () => ({
    ...state,
    listBillforms: { data: [], loading: true }
  }),
  [FETCH_BILLFORM.SUCCESS]: (data) => ({
    ...state,
    listBillforms: { data: data.data, loading: false }
  }),
  [FETCH_BILLFORM.FAILURE]: () => ({
    ...state,
    listBillforms: { data: [], loading: false }
  }),
  [GET_BILLFORM_DETAIL.REQUEST]: () => ({
    ...state,
    billformDetail: { data: {}, loading: true }
  }),
  [GET_BILLFORM_DETAIL.SUCCESS]: (data) => ({
    ...state,
    billformDetail: { data: data.data, loading: false }
  }),
  [CLEAR_BL_DETAIL]: () => ({
    ...state,
    billformDetail: { data: {}, loaded: false },
    GRSearch: { data: [], buffer: [], loaded: false },
    grReleaseDetail: null
  }),
  [GET_GR_RELEASE.REQUEST]: () => ({
    ...state,
    GRSearch: { data: [], buffer: [], loading: true }
  }),
  [GET_GR_RELEASE.SUCCESS]: (data) => ({
    ...state,
    GRSearch: { data: data.data, buffer: data.data, loading: false }
  }),
  [GET_GR_RELEASE_DETAIL.SUCCESS]: (data) => ({
    ...state,
    grReleaseDetail: data.data
  }),
  [GET_BL_GOA_WORK_FLOW_VIEW_MODE.REQUEST]: () => ({
    ...state,
    approvers: { data: [], loading: true }
  }),
  [GET_BL_GOA_WORK_FLOW_VIEW_MODE.SUCCESS]: (data) => ({
    ...state,
    approvers: { data: data.data, loading: false }
  }),
  [GET_BL_GOA_WORK_FLOW_EDIT_MODE.REQUEST]: () => ({
    ...state,
    approvers: { data: [], loading: true }
  }),
  [GET_BL_GOA_WORK_FLOW_EDIT_MODE.SUCCESS]: (data) => ({
    ...state,
    approvers: { data: data.data, loading: false }
  }),
  [GET_BL_WORKFLOW_APPROVER_VIEW.REQUEST]: () => ({
    ...state,
    approverLoading: true
  }),
  [GET_BL_WORKFLOW_APPROVER_VIEW.SUCCESS]: (data) => ({
    ...state,
    approvers: data.data,
    approverLoading: false
  }),
  [GET_BL_WORKFLOW_APPROVER_VIEW.FAILURE]: (data) => ({
    ...state,
    approvers: [],
    approverLoading: false
  }),
  [BL_FILTER_INVOICE_LIST]: (data) => {
    const { grId } = data
    let clone = JSON.parse(JSON.stringify(state.GRSearch.buffer))
    let baseIVIndex = clone.findIndex(x => x.id === grId)
    let baseIV = clone[baseIVIndex]
    let newIVList = []
    if (baseIV) {
      newIVList = clone.filter(x =>
        x.companyCode === baseIV.companyCode &&
        x.companyPlant === baseIV.companyPlant &&
        x.vendorCode === baseIV.vendorCode)
    }
    return ({
      ...state,
      GRSearch: { buffer: state.GRSearch.buffer, data: newIVList, loading: false }
    })
  },
  [BL_REMOVE_ITEM_INVOICE_LIST]: (data) => {
    const { grId } = data
    let clone = JSON.parse(JSON.stringify(state.GRSearch.data))
    let baseIVIndex = clone.findIndex(x => x.id === grId)
    clone.splice(baseIVIndex, 1)
    return ({
      ...state,
      GRSearch: { buffer: state.GRSearch.buffer, data: clone, loading: false }
    })
  },
  [BL_ADD_ITEM_INVOICE_LIST]: (data) => {
    const { grId } = data
    let clone = JSON.parse(JSON.stringify(state.GRSearch.buffer))
    let baseIVIndex = clone.findIndex(x => x.id === grId)
    let cloneBaseIV = JSON.parse(JSON.stringify(clone[baseIVIndex]))
    let cloneBaseData = JSON.parse(JSON.stringify(state.GRSearch.data))
    cloneBaseData.push(cloneBaseIV)
    return ({
      ...state,
      GRSearch: { buffer: state.GRSearch.buffer, data: cloneBaseData, loading: false }
    })
  },
  [BL_RESET_INVOICE_LIST]: () => {
    let clone = JSON.parse(JSON.stringify(state.GRSearch.buffer))
    return ({
      ...state,
      GRSearch: { buffer: clone, data: clone, loading: false }
    })
  },
  [GET_BILLING_COVER.REQUEST]: () => ({
    ...state,
    billingCoverDetail: { data: {}, loading: true }
  }),
  [GET_BILLING_COVER.SUCCESS]: (data) => ({
    ...state,
    billingCoverDetail: { data: data.data, loading: false },
  }),
  [GET_BILLING_REPORT.REQUEST]: () => ({
    ...state,
    billingReportList: { data: [], loading: true }
  }),
  [GET_BILLING_REPORT.SUCCESS]: (data) => ({
    ...state,
    billingReportList: { data: data.data, loading: false },
  }),
}))